module.exports = __webpack_public_path__ + "media/assets/images/cloudy_sometime_will_rain-2c32c381e7633fd90421c07dc6714ad5.png";